import React from 'react'

interface YesNoBadgeProps {
  value: boolean
  yesText?: string
  noText?: string
  yesColor?: string
  noColor?: string
}

export const YesNoBadge: React.FC<YesNoBadgeProps> = ({
  value,
  yesText = 'Si',
  noText = 'No',
  yesColor,
  noColor
}) => {
  const backgroundColor = value ? yesColor ?? '#1976d2' : noColor ?? '#e0e0e0'
  const colorText = value ? 'white' : noColor ? 'white' : '#616161'
  const text = value ? yesText : noText

  return (
    <div
      style={{
        display: 'inline-block',
        minWidth: 50,
        textAlign: 'center',
        borderRadius: '12px',
        padding: '2px 8px',
        fontSize: '11px',
        backgroundColor,
        color: colorText,
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 2px rgba(0,0,0,0.15)'
      }}
    >
      {text}
    </div>
  )
}
